import { useMutation } from '@apollo/client';
import { Mutation } from 'graphql/generated/graphqlTypes';
import { GO_BACK_ONE_ONBOARDING_STEP } from 'graphql/mutations';
import { setCurrentTenantAction } from 'state/actions/currentTenant';
import { BaseHookProps } from '../shared/types';

const useGoBackOneOnboardingStep = ({ handleFetchError }: BaseHookProps) => {
  const [goBackOneOnboardingStepMutation, { loading }] = useMutation<Pick<Mutation, 'goBackOneOnboardingStep'>, null>(
    GO_BACK_ONE_ONBOARDING_STEP,
    {
      onCompleted: (data) => {
        setCurrentTenantAction(data.goBackOneOnboardingStep);
      },
      onError: () => {
        handleFetchError('Error while going back one step');
      }
    }
  );

  const goBackOneOnboardingStep = async () => {
    await goBackOneOnboardingStepMutation();
  };

  return {
    loading,
    goBackOneOnboardingStep
  };
};

export default useGoBackOneOnboardingStep;
